/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   CarouselV3.tsx
 * https://github.com/YIZHUANG/react-multi-carousel/blob/master/README.md
 */
import React from 'react'

import { CarouselV3Props } from './types'
import { useCarouselV3 } from './useCarouselV3'

// Regular carousel for typical use cases
export const CarouselV3 = (props: CarouselV3Props) => {
  const { CarouselV3: CarouselComponent } = useCarouselV3()
  return <CarouselComponent {...props} />
}
